import { apiSlice } from "../apiSlice";

export const categoriesApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    addCategory: builder.mutation({
      query: (data) => ({
        url: "/categories/add-category",
        method: "POST",
        body: data,
      }),
      invalidatesTags: () => [
        { type: "categories" }, // Invalidate the customer list (only if required)
      ],
    }),

    getAllCategory: builder.query({
      query: () => `/categories`,
      keepUnusedDataFor: 6000,
      providesTags: (result) => {
        if (result?.content && Array.isArray(result.content)) {
          return [
            { type: "categories" }, // provides tag for Customer list
            ...result.content.map(({ id }) => ({ type: "category", id })), // provides tag for individual category
          ];
        }
        return [{ type: "categories" }]; // fallback in case content is not available
      },
    }),

    getCategoryById: builder.query({
      query: (id) => `/categories/category/${id}`,
      providesTags: (result, error, id) => [
        { type: "category", id }, // Provides a tag for a single customer
      ],
    }),

    updateCategory: builder.mutation({
      query: (data) => ({
        url: "/categories/update-category",
        method: "PUT",
        body: data,
      }),
      invalidatesTags: (result, error, { id }) => [
        { type: "category", id }, // Invalidate the cache for the updated customer
        { type: "categories" }, // Optionally invalidate the customers list (only if required)
      ],
    }),
    deleteCategory: builder.mutation({
      query: (id) => ({
        url: `/categories/category/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: () => [{ type: "categories" }],
    }),
  }),
});

export const {
  useAddCategoryMutation,
  useGetAllCategoryQuery,
  useGetCategoryByIdQuery,
  useUpdateCategoryMutation,
  useDeleteCategoryMutation,
} = categoriesApi;
